import { defineComponent as _defineComponent } from 'vue'
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { PropType } from 'vue';
import { ProjectOffer } from '@/models/MyProjects';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOffersStatusSelector',
  props: {
  status: {
    type: String as PropType<ProjectOffer['status']>,
    required: true
  },
  isSelected: Boolean,
},
  setup(__props) {



const { t } = useI18n();

const { isNarrow } = useMyProjects();

return { __sfc: true,t, isNarrow, BCXIcon }
}

})